'use client';

import type { SourceAccount } from '@repo/api-gw-sdk';
import { createContext, useMemo, type PropsWithChildren } from 'react';
import { useDAL } from './useDAL';
export const SourceAccountsContext = createContext<{
  sourceAccounts: SourceAccount[] | undefined;
  recalculateAccounts: () => void;
} | null>(null);
export const SourceAccountsProvider = ({
  children
}: PropsWithChildren) => {
  const dal = useDAL();
  const {
    data: sourceAccountsBody,
    mutate: mutateAccounts
  } = dal.cloudAccounts.source.useList(0, 10000);
  const sourceAccounts = useMemo(() => sourceAccountsBody?.accounts?.map(x => ({
    ...x,
    name: x.name || x.providerAccountId
  })).sort((a, b) => a.sourceAccountAttributes.cloudProvider.localeCompare(b.sourceAccountAttributes.cloudProvider) || a.name.localeCompare(b.name)), [sourceAccountsBody]);
  return <SourceAccountsContext.Provider value={{
    sourceAccounts,
    recalculateAccounts: () => void mutateAccounts()
  }}>
      {children}
    </SourceAccountsContext.Provider>;
};